import { createContext, memo, ReactNode } from "react";

export const DisabledContext = createContext<boolean>(false);

export const DisabledContextProvider = memo<{ value?: boolean | null, useParentContextValue?: boolean, children: ReactNode }>(
  (
    {
      value,
      useParentContextValue = true,
      children,
    },
  ) =>
    <DisabledContext.Consumer>
      {
        externalDisabled =>
          <DisabledContext.Provider value={(useParentContextValue && externalDisabled) || value || false}>
            {children}
          </DisabledContext.Provider>
      }
    </DisabledContext.Consumer>,
);